import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@wealthx/ui/theme";
import { ThemeProvider as ShadcnThemeProvider } from "@wealthx/shadcn/theme";
import "@wealthx/shadcn/styles.css";
import Layout from "./src/components/Layout";
import {
  TenantThemeProvider,
  useTenantTheme,
} from "./src/context/tenant-theme-context";

/**
 * * Wraps every page in a component
 */
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  window.analytics &&
    window.analytics.page(location.href, {
      path: location.pathname,
      url: location.href,
      referrer: prevLocation ? prevLocation.href : null,
    });
};

const TenantThemedApp = ({ children }) => {
  const { colors } = useTenantTheme();
  return (
    <ThemeProvider primary={colors.primary} secondary={colors.secondary}>
      <ShadcnThemeProvider
        primary={colors.primary}
        secondary={colors.secondary}
      >
        {children}
      </ShadcnThemeProvider>
    </ThemeProvider>
  );
};

export const wrapRootElement = ({ element }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <TenantThemeProvider>
        <TenantThemedApp>{element}</TenantThemedApp>
      </TenantThemeProvider>
    </QueryClientProvider>
  );
};
